import * as React from 'react'
import styled from 'styled-components'
import { sx, SxProps } from '@bestyled/system'
import { Text } from './Text'
import { filterViewProps } from '../util/filterViewProps'
import { cssReset } from '../util/css-reset'

function wrapText(children) {
  return React.Children.map(children, (item) => {
    if (typeof item === 'string') {
      return React.createElement(Text, {}, item)
    }
    return item
  })
}

/** The ViewBase component is a generic container without any default styling, padding or spacing */
export function ViewBase<T extends SxProps & any>(displayName: string) {
  const baseElement = React.forwardRef((props: any, ref) => {
    const { as, children, className, ...rest } = props

    if (props.hidden) {
      return null
    }

    const supportedProps = filterViewProps(rest)

    return React.createElement(
      props.as || 'div',
      {
        ...supportedProps,
        className,
        itemType: props.itemType || displayName,
        ref
      },
      wrapText(children)
    )

    /* Note: div must have global css elsewhere to  display: flex; align-items: stretch; box-sizing: border-box; flex-direction: column; etc. */
  })

  baseElement.displayName = displayName

  return (styled(baseElement)(cssReset('div'), sx) as unknown) as React.FC<T>
}
